import { Box } from "@mui/material"
import type { SxProps } from "@mui/material"
import { forwardRef } from "react"
import type { Props } from "simplebar-react"

import { StyledRootScrollbar, StyledScrollbar } from "./styles"

interface ScrollbarProps extends Props {
  children: React.ReactNode
  sx?: SxProps
  paddingbottom?: number
  paddingright?: number
}

const Scrollbar = forwardRef(function InnerScrollbar(
  { children, sx, paddingbottom, paddingright, ...other }: ScrollbarProps,
  ref: React.Ref<HTMLDivElement>
) {
  const userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)

  if (isMobile) {
    return (
      <Box ref={ref} sx={{ overflowX: "auto", ...sx }}>
        {children}
      </Box>
    )
  }

  return (
    <StyledRootScrollbar>
      <StyledScrollbar
        clickOnTrack={false}
        sx={sx}
        paddingbottom={paddingbottom}
        paddingright={paddingright}
        scrollableNodeProps={{ ref: ref }}
        {...other}
      >
        {children}
      </StyledScrollbar>
    </StyledRootScrollbar>
  )
})

export default Scrollbar
